import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Effectif.css";

const Effectif = () => {
    // Liste des joueurs mise à jour
    const joueurs = [
        { id: 1, number: 12, name: "Hugo PONSARD", position: "Gardien" },
        { id: 2, number: 10, name: "Hilel PENGAM", position: "Joueur" },
        { id: 3, number: 18, name: "Adam BELIARD", position: "Joueur" },
        { id: 4, number: 21, name: "Boumedyen BENSABER", position: "Joueur" },
        { id: 5, number: 3, name: "Salaydin BOURMAUD", position: "Joueur" },
        { id: 6, number: 2, name: "Mohamed CHERIH", position: "Joueur" },
        { id: 7, number: 1, name: "Kandjoura DABO DIABY", position: "Joueur" },
        { id: 8, number: 4, name: "Dama KOUCH", position: "Joueur" },
        { id: 9, number: 5, name: "Mamadou DIABY", position: "Joueur" },
        { id: 10, number: 9, name: "Adama SECK", position: "Pivot" },
        { id: 11, number: 7, name: "Corentin YOU", position: "Pivot" },
        { id: 12, number: 13, name: "David LE BOETTE", position: "Défenseur" },
        // Joueurs non présents sur la photo (Numéros à confirmer ou réservistes)
        { id: 13, number: 20, name: "Sabri BARRADAS", position: "Défenseur" },
        { id: 14, number: 11, name: "Bilal CHIHABY", position: "Défenseur" },
        { id: 15, number: 8, name: "Antoine CLEMOT", position: "Joueur" },
        { id: 16, number: 17, name: "AbdelMalek DRIOUECH", position: "Joueur" },
        { id: 17, number: 22, name: "Alikali DANSOKO", position: "Joueur" },
        { id: 18, number: 6, name: "Cédric GOSSE", position: "Joueur" },
        { id: 19, number: 23, name: "Nassim LAARAICHI", position: "Joueur" },
        { id: 20, number: 19, name: "Nouke NSAPGUE", position: "Joueur" },
    ];

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    };

    return (
        <div className="effectif-section" data-aos="fade-up">
            <h2 className="effectif-title">Effectif de l'équipe</h2>

            <div className="effectif-carousel-wrapper">
                <Slider {...settings}>
                    {joueurs.map((joueur) => (
                        <div key={joueur.id} className="carousel-item-padding">
                            <div className="joueur-card-mockup">
                                <div className="card-number">{joueur.number}</div>
                                <div className="card-details">
                                    <h3 className="card-name">
                                        {joueur.name.split(" ")[0]} <br />
                                        <span>{joueur.name.split(" ").slice(1).join(" ")}</span>
                                    </h3>
                                    <div className="card-footer-text">NDBF</div>
                                </div>
                            </div>
                        </div>
                    ))}
                </Slider>
            </div>
        </div>
    );
};

export default Effectif;
